const $navTrigger = $('.js-nav-trigger');
const $headerAside = $('.js-header-aside');

$navTrigger.on('click', function(evt) {
	evt.preventDefault();

	$(this).toggleClass('is-triggered');
	$headerAside.toggleClass('is-active');
	$('body').toggleClass('is-nav-open', $(this).hasClass('is-triggered'));
})
